module.exports = "/assets/data/77acdd3fd55828a56368e95b34cce12a-NR14.data.json";